// Core dependencies
import session from '@updater-core/interactors/shell/session';
import { ITEM_KINDS } from '@updater-core/constants/items';
import optimizely from '@updater-core/interactors/shell/optimizely';
import { createGateway as createLocalGateway } from '@updater-core/gateways/local-storage';
import createMoveItemsInteractor from '@updater-core/interactors/move-items';
import { useInteractor } from '@updater-core/view/hooks/interactor';
import { createPersistedInteractor } from '@updater-core/interactors/shell/router-persistance';
import createDomainTrackerInteractor from '@updater-core/interactors/domain-tracker';

// Apps dependencies
import { createLogger } from '@updater-apps/packing-supplies/logger';

// Local dependencies
import createInteractor from './interactor';
import { PackingSuppliesInteractor } from './types';

const { log } = createLogger('[PERSISTOR]');

const tracker = createDomainTrackerInteractor({ domain: 'ms_pod_boxes' });

export default function createPackingSuppliesInteractor(): PackingSuppliesInteractor {
  const dependencies = {
    session,
    optimizely,
    moveItems: createMoveItemsInteractor(),
    gateways: {
      storage: createLocalGateway(),
    },
    tracker,
  };

  const interactor = createPersistedInteractor({
    log,
    persistenceKey: 'upd.packing-supplies-interactor',
    createInteractor,
    dependencies,
    basePathRegExp: new RegExp(`/quick-setup/?([^?]*)`),
    onCreated: ({ actions }) => {
      const { selectors: sessionSelectors, getState: sessionGetState } =
        session;
      const sessionState = sessionGetState();

      const availableSteps = sessionSelectors
        .itemDefinitions(sessionState)
        .map(({ code }) => code);

      if (availableSteps.includes(ITEM_KINDS.PACKING_SUPPLIES)) {
        actions.initializeIntroPageVariation();
        actions.initializeVariation();
        actions.initializeEntryPointVariation();
        actions.initializeStarterKitVariation();
      }
    },
  });
  return interactor;
}

export function usePackingSuppliesInteractor(): PackingSuppliesInteractor {
  return useInteractor(createPackingSuppliesInteractor);
}
